export const theme = {
  colors: {
    white: '#ffffff',
    black: '#000000',
    background: '#ffffff',
    backgroundSecondary: '#f8f9fa',
    backgroundTertiary: '#f1f3f5',
    textPrimary: '#212529',
    textSecondary: '#6c757d',
    textTertiary: '#adb5bd',
    primary: '#0d6efd',
    primaryHover: '#0b5ed7',
    primaryActive: '#0a58ca',
    border: '#dee2e6',
    borderLight: '#e9ecef',
    success: '#198754',
    warning: '#ffc107',
    error: '#dc3545',
    info: '#0dcaf0',
    hover: '#f8f9fa',
    hoverDark: '#e9ecef',
    selected: '#e7f1ff',
    selectedBorder: '#0d6efd',
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
  },
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%',
  },
  
  fontSize: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px',
  },
  
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    md: '0 2px 4px rgba(0, 0, 0, 0.1)',
    lg: '0 4px 8px rgba(0, 0, 0, 0.15)',
    xl: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
  
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
  
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  
  sizes: {
    sidebarWidth: '48px',
    sidebarExpandedWidth: '200px',
    headerHeight: '48px',
    iconSize: '20px',
    iconSizeSmall: '16px',
    iconSizeLarge: '24px',
  },
};

export type Theme = typeof theme;
